import React, { useState } from 'react';
import SignUpForm from './SignUpForm';
import './SignUp.css';

export default function SignUpPane() {
  // const freeDeveloperDetails = ['1 User', '2 Envs', '4 Config variants',  '32 Props per config', 'Realtime Configs'];
  // const freeDeveloperDesc = 'Perfect for solo devs or personal projects. Manage Envs like "main" and "test" with config variations like per custom branch.';

  // const teamStarterDetails = ['Up to 6 Users', '4 Envs', '12 Config variants', '64 Props per config', 'Free if signup before Sep'];
  // const teamStarterDesc = 'Ideal for small startups. Shared configs with team collaboration in real time.';

  const teamProDetails = ['Up to 20 Users', '24 Envs', '50 Config Variants', '256 Props per config', 'Role-Based Access', 'Free Forever'];
  const teamProDesc = 'Best for a team, heavily loaded with various envs and config profiles.';

  const projectDetails = ['Up to 120 Users', '12 Teams', '100 Envs', '128 Config Variants', '1K Props per config', 'Free Upgrade to Config Hierarchies', 'Start free for 2 months', 'no credit cards required to try'];
  const projectDesc = 'Built for multi-team projects.';

  const enterpriseDetails = ['Unlimited Users', 'Unlimited Projects', 'Priority Support', 'Priority Customizations', 'i18n, validations, metrics', 'Try free for 60 days', 'no credit cards required to try'];
  const enterpriseDesc = 'For large, high scale orgs, tailored assistance.';

  const [activePlan, setActivePlan] = useState('');
  const selected = '' === activePlan ? '' : 'selected';

  const style = `signUpOptions ${selected}`;
  return (
    <div className="signUp">
      <div className="signUpHeader">
        <div>Sign Up</div>
        {/* <CubeTest /> */}
      </div>

      <div className={style}>
        {/* <SignUpForm
          accountPlan="singleDeveloper"
          title="Single Developer"
          bCall="Start Single Developer"
          price="Free Forever"
          curActivePlan={activePlan}
          activeSetter={setActivePlan}
          desc={freeDeveloperDesc}
          details={freeDeveloperDetails}
          tabPos="1"
        /> */}

        {/* <SignUpForm
          accountPlan="teamStarter"
          title="Team Starter"
          bCall="Start Team"
          price="Free Forever"
          curActivePlan={activePlan}
          activeSetter={setActivePlan}
          desc={teamStarterDesc}
          details={teamStarterDetails}
          tabPos="2"
        /> */}

        <SignUpForm
          accountPlan="teamPro"
          title="Team Pro"
          bCall="Start Team Pro"
          price="Free Forever"
          curActivePlan={activePlan}
          activeSetter={setActivePlan}
          desc={teamProDesc}
          details={teamProDetails}
          tabPos="3"
        />

        <SignUpForm
          accountPlan="project"
          title="Project Account"
          bCall="Start Project"
          price="$46 per month"
          curActivePlan={activePlan}
          activeSetter={setActivePlan}
          desc={projectDesc}
          details={projectDetails}
          tabPos="4"
        />

        <SignUpForm
          accountPlan="enterprise"
          title="Enterprise"
          bCall="Start Enterprise"
          price="Contact Us"
          curActivePlan={activePlan}
          activeSetter={setActivePlan}
          desc={enterpriseDesc}
          details={enterpriseDetails}
          tabPos="5"
        />

        {/* <SignUpForm
          accountPlan="global"
          title="Global"
          bCall="Contact Us"
          price="$60K per month"
          curActivePlan={activePlan}
          activeSetter={setActivePlan}
          desc={globalDesc}
          details={globalDetails}
          tabPos="6"
        /> */}
      </div>
    </div>
  );
}